export const WIREFRAME_PRIMARY_COLOR = '#808080';
export const WIREFRAME_SELECTION_COLOR = '#0073CF';
export const WIREFRAME_TEXT_COLOR = '#333333';
